import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  PO_DIALOG_CONFIG,
  PO_DIALOG_ICON,
  PO_DIALOG_VALIDATION_ERROR,
  PoDialogConfig,
  PoDialogType,
} from '../purchase-order-detail/purchase-order.constants';

export interface PoActionDialogData {
  // Pass a `type` to resolve the config from PO_DIALOG_CONFIG (purchase order usage), OR pass an
  // inline `config` to reuse this dialog from any other feature (e.g. the company lifecycle)
  // without adding entries to PO_DIALOG_CONFIG. `config` wins when both are present.
  type?: PoDialogType;
  config?: PoDialogConfig;
}

export interface PoActionDialogResult {
  confirmed: boolean;
  reason?: string;
}

/**
 * Reusable confirmation modal (Figma node 517:48563 / 773:42638).
 *
 * Driven by PO_DIALOG_CONFIG — pass a `type` ('cancel', 'lock', 'unlock', 'approve',
 * 'return_to_kam') and the dialog renders the matching icon, title, message and button
 * labels. When `textAreaPlaceholder` is set, the title moves to the header and a textarea
 * replaces the icon+message body. The parent handles the API call after the dialog closes.
 */
@Component({
  selector: 'app-po-action-dialog',
  templateUrl: './po-action-dialog.component.html',
  styleUrls: ['./po-action-dialog.component.scss'],
})
export class PoActionDialogComponent {
  readonly ICON = PO_DIALOG_ICON;
  readonly VALIDATION_ERROR = PO_DIALOG_VALIDATION_ERROR;
  readonly config: PoDialogConfig = this.data.config ?? PO_DIALOG_CONFIG[this.data.type as PoDialogType];
  reason = '';
  hasError = false;

  get hasTextArea(): boolean {
    return !!this.config.textAreaPlaceholder;
  }

  constructor(
    public readonly dialogRef: MatDialogRef<PoActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: PoActionDialogData,
  ) {}

  goBack(): void {
    this.dialogRef.close({ confirmed: false } as PoActionDialogResult);
  }

  confirmCancel(): void {
    if (this.hasTextArea && !this.reason.trim()) {
      this.hasError = true;
      return;
    }
    this.dialogRef.close({
      confirmed: true,
      reason: this.hasTextArea ? this.reason : undefined,
    } as PoActionDialogResult);
  }

  onReasonInput(): void {
    if (this.hasError && this.reason.trim()) {
      this.hasError = false;
    }
  }
}
